<template>
<PersonaContactoModal
  :show="modalPersona"
  v-model:persona="personaContacto"
  v-model:empresa="empresa.nombre"
  @crearPersona="nuevaPersonaContacto"
  @guardarPersona="modificarPersonaContacto"
  @cancelled="modalPersona=$event"
  ref="personasModal"

/>
<CCard class="mb-2">
  <CCardHeader>
    <div class="d-flex align-items-center justify-content-between">
      <span class="title-card-list">
        <CIcon name="cil-user" class="me-2" />
        {{ title }}
      </span>

    <div class="header-button-container">
      <CButton :disabled="loading" class="send-button" size="sm" color="primary" @click="personaModal()">
          Nueva
      </CButton>
    </div>
    </div>
  </CCardHeader>
  <spinner-ttt :show="loading"></spinner-ttt>
  <CCardBody>
    <CSmartTable
      v-if="loaded"
      v-model:items="items"
      :columns="camposPersonasContacto"
      :tableProps="{
            hover: true,
            striped: true,
            responsive: configResponsive
          }"
      columnSorter
      selectable
      clickable-rows
      @row-click="personaModal"
      :no-items-label="'Sin resultados'"
      @selected-items-change="items => itemsSeleccionados = items"
    >
    <template #principal="{item}">
      <td>
        <div>
          <CIcon v-if="item.principal" @click="hacerPrincipal(item, false)" name="estrellaRellenada"/>
          <CIcon v-else @click="hacerPrincipal(item, true)" name="estrella" />
        </div>
      </td>
    </template>

    <template #tipo="{item}">
      <td>
        {{ item.tipo }}
      </td>
    </template>

    <template #opciones="{item}">
      <td class="px-0">
        <div class="dropdown">
          <CIcon class="dropdown-toggle" size="lg" name="cil-options" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false" />
          <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            <li @click="eliminar(item)"><span class="dropdown-item"><CIcon size="lg" name="cil-trash" class="me-2 text-danger"/>Eliminar </span></li>
          </ul>
        </div>

      </td>
    </template>
    </CSmartTable>
    <h3 class="text-center mt-4 mb-5" v-if="items.length < 1">
      Sin resultados
    </h3>
    <div d-flex flex-row class="acciones-disponibles ms-3">
          <div class="col-12 col-md-auto">
            <CDropdown>
              <CDropdownToggle size="sm" color="primary">Acciones Globales</CDropdownToggle>
              <CDropdownMenu>
                <CDropdownItem @click="modalDelete()"><CIcon name="cil-trash" class="me-2 text-danger"/> Eliminar</CDropdownItem>
              </CDropdownMenu>
            </CDropdown>
          </div>
    </div>
  </CCardBody>
</CCard>

<toast ref="toast"></toast>
</template>

<script>
import { PERSONAS_CONTACTO_FIELDS, CONFIG_PANEL } from '@/config';
export default {
  name: 'PersonasList',
  props: {
    elemento: { type: String, default: 'Personas' },
    title: { type: String, default: 'Personas de contacto' },
    loading: Boolean,
    loaded: Boolean,
    personas: { type: Array, default() {return[]}, required: true },
    empresa: {type:Object, required: true},

    rows: { type: Number, default: 0 },
    currentPage:  { type: Number, default: 1 },
    perPage:  { type: Number, default: 25 },
    total_paginas:  { type: Number, default: 1 },
  },
  data() {
    return {
      camposPersonasContacto: [
        // { key: "id", label: "Id", sorter: true ,  _style: 'width:5%' },
        {key: 'principal', label: '', sorter: false},
        {key: 'nombre', label: 'Nombre', sorter: true},
        {key: 'email', label: 'Email', sorter: true},
        {key: 'telefono', label: 'Teléfono', sorter: true},
        {key: 'tipo', label: 'Tipo', sorter: false},
        {key: 'opciones', label: '', sorter: false}
      ],
      element: 'Persona',
      personaContacto: {...PERSONAS_CONTACTO_FIELDS},
      modalPersona: false,
      itemsSeleccionados: [],
    }
  },
  computed: {
    items:{
      get: function () {
        return this.personas;
      },
      set: function (newValue) {
        this.$emit("update:personas", newValue);
      },
    },
    currentPageSon: {
      get: function() {
        return this.currentPage;
      },
      set: function(newValue) {
        this.$emit('update:currentPage', newValue)
      }
    },
    loadingList: {
      get: function() {
        return this.loading;
      },
      set: function(newValue) {
        this.$emit('update:loading', newValue)
      }
    },
    configResponsive() {
      return CONFIG_PANEL.responsive;
    }
  },
  methods: {
    getRowCount: function() {
      return this.rows;
    },

    personaModal(item = null, index, column, e) {
      if(!item || (item && ![ 'nombre', 'principal', undefined].includes(column))) {
        if (item) {
          this.personaContacto = { ...item};
        }
        this.modalPersona = true;
      }
    },

    checkearSeleccionados() {
      this.items.map(item => item._selected = false);

      this.itemsSeleccionados.forEach(item => {
        this.items[this.items.indexOf(this.items.filter(i => i.id == item.id)[0])]._selected = item._selected;
      });

      this.items = [...this.items];

      return this.items.filter(item => item._selected === true);
    },

    nuevaPersonaContacto() {
      this.personaContacto.empresa_id = this.empresa.id;
      this.$emit('nuevaPersona', this.personaContacto);
    },

    modificarPersonaContacto() {
      this.personaContacto.empresa_id = this.empresa.id;
      this.$emit('modificarPersona', this.personaContacto);
    },

    modalDelete(){
      const checked = this.checkearSeleccionados();

      if(checked.length){
        this.$emit('delete', true)
      } else {
        this.$refs.toast.showToast(`No se ha seleccionado una persona para eliminar.`, null, 'warn', '5000');
      }
    },

    eliminar(item) {
      this.deleteItem = item;
      this.$emit('deletePersona', this.deleteItem)
    },

    hacerPrincipal(item, v) {
      item.principal = v;

      this.$emit('hacerPrincipal', item);
    },

    cerrarModal() {
      this.$refs.personasModal.cerrarModal()
    }
  }
}
</script>

<style>

</style>
